import News from "./News";
import useNews from "hooks/useNews";
import DefaultTemplate from "components/templates/DefaultTemplate";

const Home = () => {
    const { news, getNews, isLoading } = useNews();
    if (isLoading) getNews();

    return (
        <DefaultTemplate style={{ textAlign: "center" }}>
            <h2>店舗ニュース</h2>
            {isLoading ? (
                <h2>Now Loading...</h2>
            ) : (
                <div style={{ display: "flex", flexWrap: "wrap" }}>
                    {news.length ? (
                        <>
                            {news.map((val) => (
                                <News
                                    key={val.id}
                                    title={val.title}
                                    text={val.text}
                                    image={val.image}
                                    date={val.date}
                                />
                            ))}
                        </>
                    ) : (
                        <p>ニュースがありません</p>
                    )}
                </div>
            )}
        </DefaultTemplate>
    );
};

export default Home;
